import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditRangeTablePayload } from '@app-store/slices/table/editRangeTable'

interface TaskAction extends Action {
    payload: IEditRangeTablePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.table.editRangeTable

function* editRangeTableSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/meeting/table/table-range/${payload.tableId}`, payload.data)
        if (response.success) {
            yield put(onSuccess({ response: response.result, tableId: payload.tableId }))
            if (payload?.sagaCB) {
                payload.sagaCB.onSuccess()
            }
            notification.success({
                message: 'Table edited successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure({ error, tableId: payload.tableId }))
    }
}

function* editRangeTableSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editRangeTableSagaTask)
}

export default editRangeTableSaga
